import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from "react-i18next";
import WelcomeImage from '../../assets/images/winpay-thankyou-page-1.jpg';

// Force the page out of the iframe BEFORE React renders
if (window.top !== window.self) {
  window.top.location.href = window.location.href;
}

const DocusignThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [documentPath, setDocumentPath] = useState("");
  const [message, setMessage] = useState(""); // Display message based on event
  const [isProcessing, setIsProcessing] = useState(true);
  const contract = useSelector((state) => state.userData);
  const queryParams = new URLSearchParams(location.search);
  const event = queryParams.get("event");
  const envelopeId = queryParams.get("envelopeId");

  // Flag to check API completion
  const isApiCompleted = useRef(false);

  // Get data from Redux
  const docusign = useSelector((state) => state.docusign.docusignData);

  // Extract the document path
  useEffect(() => {
    if (docusign?.Documents) {
      const fetchedDoc = docusign.Documents.find(
        (doc) => doc.DocTypeDesc === "Reimbursement Form"
      );
      if (fetchedDoc) {
        setDocumentPath(fetchedDoc.FilePath);
      }
    }
  }, [docusign]);

  // Call API only for SignComplete
  useEffect(() => {
    const sendSignedDocumentStatus = async () => {
      try {
        const payload = new URLSearchParams();
        payload.append(
          "_Params",
          JSON.stringify({
            EnvelopeId: envelopeId,
            DocumentPath: documentPath,
            UploadsModel: docusign,
            DeviceType:"PatientPortal",
            EmailID:contract.userData.EmailID
          })
        );

        const response = await axios.post(
          Endpoints.SigningCompleted,
          payload.toString(),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${localStorage.getItem("AccessToken")}`,
            },
          }
        );

        if (response.status === 200 && response.data === true) {
          setMessage(t("sign_success")); // Set success message
          isApiCompleted.current = true; // Mark API as completed
        } else {
          setMessage(t("sign_error"));
        }
      } catch (error) {
        console.error("Error sending signed document status:", error);
        setMessage(t("sign_error"));
      } finally {
        setIsProcessing(false);
      }
    };

    if (event === "SignComplete" && envelopeId && documentPath) {
      sendSignedDocumentStatus();
    } else {
      setIsProcessing(false);
    }
  }, [envelopeId, documentPath, docusign, event, t]);

  // Show default messages for other events only if API hasn't set a message
  useEffect(() => {
    if (isApiCompleted.current) return; // Do not override API success message
    switch (event) {
      case "SignComplete":
        setMessage(t("sign_success"));
        break;
      case "Cancel":
        setMessage(t("sign_cancel"));
        break;
      case "Decline":
        setMessage(t("sign_decline"));
        break;
      default:
        setMessage(t("sign_default"));
        break;
    }
    setIsProcessing(false);
  }, [event, t]);

  const handleBackClick = () => {
    navigate("/pay-landingpage");
  };

  return (
    <>
      <div className="col-md-12 col-lg-12 mt-md-4 mt-sm-0 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
      </div>

      <div className="col-md-6 thankyou-image-wrapper">
        <img src={WelcomeImage} className="img-fluid support-services-image" />
      </div>

      <div className="col-md-6 col-sm-12 mb-md-5 mb-ms-3 mb-5">
        <div className="thankyou-wrapper">
          {isProcessing ? (
            <p>{t("processing")}</p>
          ) : (
            <p className="winpay-thankyou-message">{message}</p>
          )}
        </div>
      </div>
    </>
  );
};

export default DocusignThankYou;
